import { render, staticRenderFns } from "./CIcon.vue?vue&type=template&id=f7e879c8&scoped=true"
import script from "./CIcon.vue?vue&type=script&lang=js"
export * from "./CIcon.vue?vue&type=script&lang=js"
import style0 from "./CIcon.vue?vue&type=style&index=0&id=f7e879c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e879c8",
  null
  
)

export default component.exports